import Home from './containers/Home';
import AboutUs from './containers/AboutUs';
import STCH from './containers/STCH';
import Login from './containers/Login';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import NotFound from './containers/NotFound';
import Management from './containers/AdminManagement';
import Trainee from './containers/Trainee';
import Supervisor from './containers/Supervisor';
import CFINavbar from './containers/CFINavbar';
import React from 'react';
import AuthenticatedRoute from './components/AuthenticatedRoute';
import UnauthenticatedRoute from './components/UnauthenticatedRoute';
import Footer from './containers/Footer';

<script src="https://kit.fontawesome.com/8537d1aa4b.js" crossorigin="anonymous"></script>

export const AuthContext = React.createContext();
const initialState = {
    isAuthenticated: false,
    user: null,
    token: null,
};
const reducer = (state, action) => {
    // console.log('Reducer action', action)
    switch (action.type) {
        case "LOGIN":
            localStorage.setItem("user", JSON.stringify(action.payload.user));
            localStorage.setItem("token", JSON.stringify(action.payload.access_token));
            return {
                ...state,
                isAuthenticated: true,
                user: action.payload.user,
                token: action.payload.access_token
            };
        case "LOGOUT":
            localStorage.clear();
            return {
                ...state,
                isAuthenticated: false,
                user: null
            };
        case "UPDATE":
            console.log('Running UPDATE reducer ');
            return {
                ...state,
                user: action.payload.user
            };
        case "FAIL":
            console.log('A FAILED upload ');
            return {
                ...state,
                user: action.payload.user
            };
        default:
            console.log('running default reducer ');
            return {
                ...state,
                user: action.payload.user
            };
    }
};


function App() {

    const [state, dispatch] = React.useReducer(reducer, initialState);

    return (

        <AuthContext.Provider
            value={{
                state,
                dispatch
            }}
        >
            <Router>

                    <CFINavbar />
                        <Routes>
                            <Route exact path="/" element={<Home />} />
                            <Route path="about/*" element={<AboutUs />} />
                            {/* TODO When have new products turn the nav into a select and switch links here */}
                            <Route path="STCH/*" element={<STCH />} /> 

                            <Route
                                path="/login"
                                element={
                                    <UnauthenticatedRoute>
                                        <Login />
                                    </UnauthenticatedRoute>
                                }
                            />
                            <Route
                                path="/admin_management"
                                element={
                                    <AuthenticatedRoute>
                                        <Management />
                                    </AuthenticatedRoute>
                                }
                            />
                            <Route
                                path="/results"
                                element={
                                    <AuthenticatedRoute>
                                        <Trainee />
                                    </AuthenticatedRoute>
                                }
                            />
                            <Route
                                path="/supervisor"
                                element={
                                    <AuthenticatedRoute>
                                        <Supervisor />
                                    </AuthenticatedRoute>
                                }
                            />

                            <Route component={NotFound} />

                        </Routes>
                    <Footer />
            </Router>
        </AuthContext.Provider>
    );
}

export default App;
